//import router from "@/router";
import Cookies from "js-cookie";
import { getUrlParams, initLocalName } from "@/utils";
import { Cats } from "@/api/user";
import { db } from "@/db";

const state = {
  API_TOKEN:
    process.env.NODE_ENV == "development" ? process.env.VUE_APP_API_TOKEN : "", //getToken(),
    loginInfo: false,
};

const mutations = {
  SET_API_TOKEN: (state, data) => {
    state.API_TOKEN = data;
  },
  SET_LOGIN_INFO: (state, data) => {
    state.loginInfo = data;
  },
};

const actions = {
  changeApiToken({ commit, dispatch }, data) {
    commit("SET_API_TOKEN", data);
  },
  changeLoginInfo({ commit, dispatch }, data) {
    commit("SET_LOGIN_INFO", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
